// import { getAgreement } from "@/api/init"
import {DISAPPEAR,PRIVACY_AGREEMENT,USER_AGREEMENT} from "@/utils/key.js"
import Cookies from 'js-cookie'
export default {
    state:{
		wxconfig:{}, // 微信配置
	},
    mutations:{
		getWxconfig(state, data){
            state.wxconfig = data;
        },
	},
    actions: {
        init({ dispatch }) {
            // dispatch('agreement');
        },
        // 各种协议
        // async agreement() {
        //     let {code,data } = await getAgreement()
        //     if (code == 200) {
        //         Cookies.set(DISAPPEAR, data.disappear)
        //         Cookies.set(PRIVACY_AGREEMENT, data.privacy_agreement) // 隐私政策
        //         Cookies.set(USER_AGREEMENT, data.user_agreement) // 用户协议
        //     }
        // },
    }
}